/*----------------------------------
- CONTEXTUAL RELATED LINKS
----------------------------------*/

export type RelatedLink = {
    label: string;
    href: string;
    /** A page's own analytics for this link. */
    onClick?: () => void;
};

type RelatedLinksProps = {
    links: readonly RelatedLink[];
    title?: string;
    className?: string;
};

const RelatedLinks = ({ links, title = 'Related pages', className = '' }: RelatedLinksProps) => {
    if (links.length === 0) return null;

    return (
        <section
            class={[
                'mx-auto max-w-[1240px] px-4 pt-20 sm:px-6 lg:px-8 lg:pt-24',
                className,
            ].filter(Boolean).join(' ')}
        >
            <div class="rounded-[28px] bg-[#f1ede7] p-3 sm:p-4">
                <h2 class="px-3 pb-3 pt-2 text-[12px] font-bold uppercase tracking-[0.13em] text-slate-600">
                    {title}
                </h2>
                <nav aria-label={title}>
                    <ul class="grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
                        {links.map((link) => (
                            <li key={`${link.href}-${link.label}`}>
                                <a
                                    href={link.href}
                                    onClick={link.onClick}
                                    class="flex min-h-14 items-center justify-between gap-4 rounded-[18px] bg-[#f9f8f6] px-5 py-4 text-[14.5px] font-semibold text-slate-900 transition hover:bg-white hover:shadow-[0_10px_22px_rgba(27,29,30,0.08)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-400"
                                >
                                    <span>{link.label}</span>
                                    <span aria-hidden="true" class="text-slate-400">
                                        →
                                    </span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </section>
    );
};

export default RelatedLinks;
